export default "__VITE_ASSET__gVZmi1ma__"